import {animated} from 'react-spring';

import styled from 'styled-components';

import BaseCloseIcon from '@edna/icons/close.svg';

import Button, {LoadingButton} from '../Button';
import {H2} from '../primitives';
import {mixins} from '../styles';

type TWindowProps = {
  width: string;
};

export const Background = styled(animated.div).attrs({role: 'button'})`
  ${mixins.wh('100%')}
  ${mixins.position({
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  })}
  z-index: ${({theme}) => theme.zIndex.modal};
  overflow-y: auto;

  ${mixins.media.tablet`
    width: 100vw;
  `}
`;

export const ModalWrapper = styled(animated.div)`
  ${mixins.wh('100%')}
  outline: none;
`;

export const Header = styled(H2)`
  position: relative;
  margin: 0;
  padding: ${({theme: {spacing}}) => `${spacing.s6} ${spacing.s8} ${spacing.s4}`};
`;

export const Content = styled.div`
  padding: ${({theme: {spacing}}) => `${spacing.s4} ${spacing.s8}`};
`;

export const Actions = styled.div`
  ${mixins.flexAlign('flex-end', 'center')}
  padding: ${({theme}) => `${theme.spacing.s4} ${theme.spacing.s7} ${theme.spacing.s6}`};
`;

const CLOSE_SIZE = 32;

export const CloseIcon = styled(BaseCloseIcon)`
  ${mixins.wh(`${CLOSE_SIZE}px`)}
  ${mixins.position({
    position: 'absolute',
    right: `-${CLOSE_SIZE + 8}px`,
    top: `-${CLOSE_SIZE - 3}px`,
  })}
  cursor: pointer;
  color: ${({theme}) => theme.palette.white};
`;

export const WindowWrapper = styled.div`
  ${mixins.column}
  ${mixins.paper}
  position: relative;
  width: max-content;
  min-height: 100%;
  border: none;
  border-radius: ${({theme}) => theme.borderRadius.modal};
`;

export const Window = styled.div<TWindowProps>`
  width: ${({width}) => width};
`;

export const Modal = styled.div`
  position: relative;
  min-height: 100%;
  padding: ${({theme}) => `${theme.spacing.s8} 0`};
  ${mixins.flexAlign('center')}
  ${mixins.media.tablet`
    margin-left: calc(100vw - 100%);
  `}
`;

export const ModalSubmitButton = styled(LoadingButton).attrs({
  appearance: 'primary',
  type: 'submit',
})`
  min-width: 100px;
`;

export const ModalCancelButton = styled(Button).attrs({
  appearance: 'secondary',
  name: 'cancel',
})`
  min-width: 100px;
  margin-right: ${({theme: {spacing}}) => spacing.s4};
`;
